/* Publish by EComposer at 2026-10-14 11:04:41*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yv1m0zqtbo"]=  window.__ectimmers["ecom-yv1m0zqtbo"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-yv1m0zqtbo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yv1m0zqtbo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-z5wg181kwdm"]=  window.__ectimmers["ecom-z5wg181kwdm"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const s=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",s),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},n=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",s),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",n),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-z5wg181kwdm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z5wg181kwdm', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}